(() => {
  const stylesheet = document.getElementById('pt-collection-icon-css');
  if (!stylesheet || stylesheet.hasAttribute('href')) return;
  const selector = '.fa,.fas,.far,.fab,.fal,.fat,.fad,.fass,.fasr,.fasl,.fast,[class^="fa-"],[class*=" fa-"]';
  const hasIcon = node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
  const load = () => {
    observer.disconnect();
    stylesheet.href = stylesheet.dataset.href;
  };
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target.matches(selector)) {
        load();
        return;
      }
      for (const node of record.addedNodes) {
        if (hasIcon(node)) {
          load();
          return;
        }
      }
    }
  });
  if (document.querySelector(selector)) {
    load();
    return;
  }
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
